"use client"

import { useTheme } from "./theme-provider"

export default function Navbar({ onNavigate }) {
  const { theme, toggleTheme } = useTheme()

  const handleNavClick = (e, view) => {
    e.preventDefault()
    if (onNavigate) {
      onNavigate(view)
    }
  }

  return (
    <nav
      className="navbar navbar-expand-lg modern-navbar"
      style={{
        backgroundColor: theme === "dark" ? "rgba(26, 26, 46, 0.95)" : "rgba(255, 255, 255, 0.95)",
        backdropFilter: "blur(20px)",
        boxShadow: "0 4px 20px rgba(0, 0, 0, 0.3)",
        borderBottom: theme === "dark" ? "1px solid rgba(255, 255, 255, 0.1)" : "1px solid rgba(0, 0, 0, 0.1)",
      }}
    >
      <div className="container">
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
          style={{
            border: "1px solid rgba(6, 255, 165, 0.3)",
            padding: "0.5rem"
          }}
        >
          <span style={{ color: "#06ffa5", fontSize: "1.5rem" }}>☰</span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav me-auto mb-2 mb-lg-0">
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="/" 
                onClick={(e) => handleNavClick(e, "dashboard")}
                style={{ 
                  color: theme === "dark" ? "#ffffff" : "#1a1a2e", 
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "1rem",
                  padding: "0.5rem 1rem",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.color = "#06ffa5"}
                onMouseLeave={(e) => e.target.style.color = theme === "dark" ? "#ffffff" : "#1a1a2e"}
              >
                Home
              </a>
            </li>
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="/brain" 
                onClick={(e) => handleNavClick(e, "brain")}
                style={{ 
                  color: theme === "dark" ? "#e0e0e0" : "#2d3748", 
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "1rem",
                  padding: "0.5rem 1rem",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.color = "#06ffa5"}
                onMouseLeave={(e) => e.target.style.color = theme === "dark" ? "#e0e0e0" : "#2d3748"}
              >
                Brain Activity
              </a>
            </li>
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="/scenarios" 
                onClick={(e) => handleNavClick(e, "scenarios")}
                style={{ 
                  color: theme === "dark" ? "#e0e0e0" : "#2d3748", 
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "1rem",
                  padding: "0.5rem 1rem",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.color = "#06ffa5"}
                onMouseLeave={(e) => e.target.style.color = theme === "dark" ? "#e0e0e0" : "#2d3748"}
              >
                Scenarios
              </a>
            </li>
            <li className="nav-item">
              <a 
                className="nav-link" 
                href="/about" 
                onClick={(e) => handleNavClick(e, "about")}
                style={{ 
                  color: theme === "dark" ? "#e0e0e0" : "#2d3748", 
                  cursor: "pointer",
                  fontWeight: "600",
                  fontSize: "1rem",
                  padding: "0.5rem 1rem",
                  transition: "all 0.3s ease"
                }}
                onMouseEnter={(e) => e.target.style.color = "#06ffa5"}
                onMouseLeave={(e) => e.target.style.color = theme === "dark" ? "#e0e0e0" : "#2d3748"}
              >
                About Us
              </a>
            </li>
          </ul>
          <div className="d-flex align-items-center gap-3">
            <button 
              className="theme-toggle" 
              onClick={toggleTheme} 
              aria-label="Toggle dark mode" 
              style={{ 
                color: theme === "dark" ? "#06ffa5" : "#1a1a2e",
                background: "rgba(6, 255, 165, 0.1)",
                border: "1px solid rgba(6, 255, 165, 0.3)",
                fontSize: "1.2rem",
                cursor: "pointer",
                padding: "0.5rem 0.75rem",
                borderRadius: "10px",
                transition: "all 0.3s ease"
              }}
            >
              {theme === "dark" ? "☀️" : "🌙"}
            </button>
            <span 
              className="badge" 
              style={{ 
                backgroundColor: "#06ffa5", 
                color: "#000",
                padding: "0.6rem 1.2rem",
                borderRadius: "20px",
                fontWeight: "700",
                fontSize: "0.85rem",
                letterSpacing: "0.5px"
              }}
            >
              AI-POWERED
            </span>
          </div>
        </div>
      </div>
    </nav>
  )
}
